<template>
	<div class="private-order-wholesale">
		<div
			v-for="(wholesale, index) in wolesaleData"
			:key="`a${index}`"
			class="wholesale-row-wrapper"
		>
			<div
				v-for="(item, i) in wholesale"
				:key="`b${index}${i}`"
				class="wholesale-item-wrapper"
				:class="{ 'with-border': wholesale.length - 1 !== i }"
			>
				<span class="price">
					{{ formatMoney(item.price, 'IDR', false) }}
				</span>

				<span class="items">
					{{ `${item.min} - ${item.max} items` }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { formatMoney } from '@/lib/helper';

export default {
	props: {
		wholesales: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		wolesaleData() {
			const chunkSize = 3;
			const wholesale = [];

			for (let i = 0; i < this.wholesales.length; i += chunkSize) {
				wholesale.push(this.wholesales.slice(i, i + chunkSize));
			}

			return wholesale;
		},
	},
	methods: {
		formatMoney,
	},
};
</script>

<style scoped lang="scss">
.private-order-wholesale {
	width: 100%;
	height: auto;
	background-color: #ffffff;
	border-radius: 8px;
	padding: 6px 10px 6px 10px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.075);
    border: 0.5px solid #d9dadd75;

	@media screen and (min-width: 1280px) {
		padding: 12px 20px 12px 20px;
	}
}

.wholesale-row-wrapper {
	width: 100%;
	height: 56px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 6px;

	@media screen and (min-width: 1280px) {
		gap: 12px;
	}
}

.wholesale-item-wrapper {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;

	&.with-border {
		border-right: 1px solid #d9dadd73;
	}

	& > span.price {
		font-size: 16px;
		line-height: 24px;
		font-weight: 600;
		color: #000000;

		@media screen and (min-width: 1280px) {
			font-size: 18px;
			line-height: 26px;
		}
	}

	& > span.items {
		font-size: 12px;
		line-height: 20px;
		font-weight: 400;
		color: #80848e;

		@media screen and (min-width: 1280px) {
			font-size: 14px;
			line-height: 22px;
		}
	}
}
</style>
